import { Box, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import ILiquidityPoolDto from "../../../interfaces/liquidity-pool/ILiquidityPoolDto";
import { NetworkEnum, NetworkLabel } from "../../../common/enum/network-enum";

export interface PoolFiltersState {
  network: string;
  protocol: string;
  walletId: string;
}

interface Props {
  pools: ILiquidityPoolDto[];
  filters: PoolFiltersState;
  onChange: (filters: PoolFiltersState) => void;
}

export default function PoolFilters({ pools, filters, onChange }: Props) {
  const networks = Array.from(new Set(pools.map(p => p.network)));
  const protocols = Array.from(new Set(pools.map(p => p.protocol)));
  const wallets = Array.from(
    new Map(pools.filter(p => p.walletId && p.walletName).map(p => [p.walletId, p.walletName!])).entries()
  );

  function handleChange(field: keyof PoolFiltersState) {
    return (e: SelectChangeEvent) => onChange({ ...filters, [field]: e.target.value });
  }

  return (
    <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
      <FormControl size="small" sx={{ minWidth: 160 }}>
        <InputLabel>Rede</InputLabel>
        <Select value={filters.network} label="Rede" onChange={handleChange('network')}>
          <MenuItem value="">Todas</MenuItem>
          {networks.map(n => (
            <MenuItem key={n} value={String(n)}>
              {NetworkLabel[n as NetworkEnum] ?? n}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl size="small" sx={{ minWidth: 160 }}>
        <InputLabel>Protocolo</InputLabel>
        <Select value={filters.protocol} label="Protocolo" onChange={handleChange('protocol')}>
          <MenuItem value="">Todos</MenuItem>
          {protocols.map(p => (
            <MenuItem key={p} value={p}>{p}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl size="small" sx={{ minWidth: 180 }}>
        <InputLabel>Carteira</InputLabel>
        <Select value={filters.walletId} label="Carteira" onChange={handleChange('walletId')}>
          <MenuItem value="">Todas</MenuItem>
          {wallets.map(([id, name]) => (
            <MenuItem key={id} value={id}>{name}</MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}
